<template lang="html">
  <svg
    viewBox="0 0 32 28.234"
    :width="width"
    :height="height"
    :fill="color"
  ><defs></defs><g transform="translate(-39 -388.981)"><g transform="translate(39 388.981)"><path d="M23.529,28.235a.941.941,0,1,1,0-1.882,6.588,6.588,0,0,0,6.588-6.588V8.471a6.588,6.588,0,0,0-6.588-6.588H8.471A6.588,6.588,0,0,0,1.882,8.471V19.765a6.588,6.588,0,0,0,6.588,6.588h9.412a.941.941,0,0,1,0,1.882H8.471A8.471,8.471,0,0,1,0,19.765V8.471A8.471,8.471,0,0,1,8.471,0H23.529A8.471,8.471,0,0,1,32,8.471V19.765A8.471,8.471,0,0,1,23.529,28.235Z" transform="translate(0)"/><path d="M24.3,27.774a1.111,1.111,0,0,1-.474-.108.888.888,0,0,1-.535-.788v-8.8a1.016,1.016,0,0,1,2.018,0V25.2l9.279-5.492L25.312,14.22v.251a1.016,1.016,0,0,1-2.018,0V12.545a.888.888,0,0,1,.534-.789,1.119,1.119,0,0,1,1.035.045l12.11,7.167a.843.843,0,0,1,0,1.487l-12.11,7.167A1.068,1.068,0,0,1,24.3,27.774Z" transform="translate(-12.571 -5.594)"/></g></g></svg>
</template>

<script>
  import mixinIcons from '../mixins/mixin-icons.js'

  export default {
    mixins: [
      mixinIcons
    ]
  };
</script>

<style lang="css" scoped>
  .a{fill:#375197;fill-rule:evenodd;}
</style>



// WEBPACK FOOTER //
// src/components/icons/SimulatorIcon.vue